{#if teachers?.length}
    <div class="itsl-course-info-box__teachers">
        <div class="itsl-course-info-box__teachers__title">{courseTeachersTitle}</div>
        <div class="itsl-course-info-box__teachers__list">
            {#each teachers as teacher}
                <Profile size={avatarSize} src={teacher.profileUrl} name={teacher.fullName} />
            {/each}
        </div>
    </div>
{/if}

<script>
    import Profile from "@itslearning/prometheus/assets/nodes/Profile/v1/Profile.svelte";

    export let courseTeachersTitle;
    export let teachers;

    const avatarSize = 200;
</script>
